<template>
  <layout
    v-if="
      wedSiteInfo &&
      (!wedSiteInfo.parceria ||
        wedSiteInfo.parceria === 'assessoriavip_sem_rsvp')
    "
    titlePage="Convidados (RSVP)"
  >
    <HeaderGuests />
    <ListGuests />
    <ModalCreateRsvpInvites />
  </layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import layout from '@/layouts/Default.vue'
import ListGuests from '@/components/Rsvp/ListGuests.vue'
import HeaderGuests from '@/components/Rsvp/HeaderGuests.vue'
import ModalCreateRsvpInvites from '@/components/Rsvp/Modals/ModalCreateRsvpInvites.vue'

export default {
  components: {
    layout,
    ListGuests,
    HeaderGuests,
    ModalCreateRsvpInvites,
  },

  metaInfo: {
    title: 'RSVP - Meus convidados',
  },

  computed: {
    ...mapGetters({
      wedSiteInfo: 'app/getWedSiteInfo',
      getRsvps: 'getRsvps',
    }),

    hasAdvisor() {
      return this.wedSiteInfo?.parceria === 'assessoriavip'
    },
  },

  mounted() {
    if (this.hasAdvisor) this.$router.push({ name: 'rsvp-configuracoes' })
    else this.fetchData()
  },

  methods: {
    ...mapActions({
      fetchRsvps: 'fetchRsvps',
      fetchRsvpConfigs: 'fetchRsvpConfigs',
    }),

    fetchData() {
      Promise.all([this.fetchRsvps(), this.fetchRsvpConfigs()])
    },
  },
}
</script>

<style lang="scss"></style>
